__turbopack_context__.v({
  "className": "serrif_7168ebae-module__9yXVKq__className",
  "variable": "serrif_7168ebae-module__9yXVKq__variable",
});
